<template>
    <div>
        <div style="padding: 20px;">
            <jt-dynamic-form
                v-if="formModel"
                ref="jtDynamicForm"
                :inputs="formModel.inputs"
                :interface="formModel.nmInterface"
                :relacionamentos="formModel.relacionamentos"
                :model="collectionPoint"
                no-scroll
                form-class="jtDFModalReasonJustificationWaste"
            />
        </div>
        <div class="row full-width q-col-gutter-lg justify-center q-py-lg">
          <div class="col-lg-2 col-md-3">
              <q-btn class="full-width" color="blue-grey" @click="limparFormulario()">
              Limpar
              </q-btn>
          </div>
          <div class="col-lg-2 col-md-3">
            <q-btn class="full-width" color="info" @click="pesquisar()">
              Pesquisar
            </q-btn>
          </div>
      </div>
    </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtTextInput, JtSelect } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'

@Component({
  components: {
    JtTextInput,
    JtSelect
  },
  name: 'CollectionPointSearchPage'
})
class CollectionPointSearchPage extends Vue {
    formModel = {};
    collectionPoint = {};

    created () {
      this.generateForm()
    }

    async generateForm () {
      const form = await repository.resolve('collectionPoint.searchCollectionPoint', {})
      this.formModel = form[0]
      this.collectionPoint.available = true
    }

    limparFormulario () {
      this.collectionPoint.name = null
      this.collectionPoint.available = false
      this.collectionPoint.areaCode = null
    }

    pesquisar () {
      this.$emit('pesquisar', this.collectionPoint)
    }

    async actionButton (button, params, page) {
      this.$emit('confirm', this.collectionPoint)
    }
}
export default CollectionPointSearchPage
</script>
<style lang="stylus" scoped>
</style>
